<template>
  <b-collapse :key="componentKey" class="panel">
    <!--<div slot="trigger" class="panel-heading">
      <strong>Dettagli</strong>
    </div>-->
    <div class="panel-block">
      <div style="width: 100%">
        <b-field
          :type="errors['name'] ? 'is-danger' : ''"
          :message="errors['name']"
        >
          <b-input
            placeholder="titolo preventivo"
            size="is-small"
            :value="item['name']"
            @input="update('name', $event)"
          />
        </b-field>
        <b-field
          :type="errors['name'] ? 'is-danger' : ''"
          :message="errors['name']"
        >
          <model-autocomplete
            placeholder="Cliente"
            model="search/customers"
            :preselect="item['customer']"
            @select="update('customer', $event)"
          ></model-autocomplete>
        </b-field>
        <b-field
          :type="errors['date'] ? 'is-danger' : ''"
          :message="errors['date']"
        >
          <datepicker
            size="is-small"
            :value="
              formData.date
                ? new Date(formData.date)
                : item.date
                ? new Date(item.date)
                : null
            "
            @input="update('date', formatDate($event))"
          ></datepicker>
        </b-field>
        <b-field
          :type="errors['expiration_date'] ? 'is-danger' : ''"
          :message="errors['expiration_date']"
        >
          <datepicker
            size="is-small"
            editable
            :value="
              formData.expiration_date
                ? new Date(formData.expiration_date)
                : item.expiration_date
                ? new Date(item.expiration_date)
                : null
            "
            @input="update('expiration_date', formatDate($event))"
          ></datepicker>
        </b-field>
        <b-field
          v-if="item.id"
          :type="errors['payment_method'] ? 'is-danger' : ''"
          :message="errors['payment_method']"
        >
          <b-select
            size="is-small"
            :value="item.payment_method"
            @input="update('payment_method', $event)"
          >
            <option :value="null">-----</option>
            <option value="BONIFICO">bonifico bancario</option>
            <option value="BONIFICO_PRE">bonifico anticipato</option>
            <option value="BONIFICO_30">
              bonifico bancario 30gg fm + 10gg
            </option>
            <option value="BONIFICO_30_DF">
              bonifico bancario 30gg df + 10gg
            </option>
            <option value="CARTE">carta di credito</option>
            <option value="NOLEGGIO_OP">
              noleggio operativo
            </option>
          </b-select>
        </b-field>
        <b-field
          :type="errors['payment_method_details'] ? 'is-danger' : ''"
          :message="errors['payment_method_details']"
        >
          <b-input
            placeholder="Dettagli pagamento"
            size="is-small"
            :value="item['payment_method_details']"
            @input="update('payment_method_details', $event)"
          />
        </b-field>
        <b-field
          :type="errors['is_closed'] ? 'is-danger' : ''"
          :message="errors['is_closed']"
        >
          <b-checkbox
            size="is-small"
            :value="item['is_closed']"
            @input="update('is_closed', $event)"
          ></b-checkbox>
          <small>chiuso</small>
        </b-field>
        <b-field
          :type="errors['notes'] ? 'is-danger' : ''"
          :message="errors['notes']"
        >
          <b-input
            placeholder="Note"
            size="is-small"
            type="textarea"
            rows="3"
            :value="item['notes']"
            @input="update('notes', $event)"
          />
        </b-field>
        <footer v-if="!isEmpty(formData)" style="margin-top: 1.5em">
          <div class="buttons">
            <button class="button is-small" type="button" @click="reset">
              <b-icon icon="undo"></b-icon>
              <span>Annulla</span>
            </button>
            <button
              class="button is-small is-primary"
              type="submit"
              @click="submit()"
            >
              <b-icon icon="save"></b-icon>
              <span>Salva</span>
            </button>
            <button
              class="button is-small is-primary"
              type="submit"
              @click="submit('print')"
            >
              <b-icon icon="print"></b-icon>
              <span>Salva e stampa</span>
            </button>
            <button
              class="button is-small is-primary"
              type="submit"
              @click="submit('duplicate')"
            >
              <b-icon icon="copy"></b-icon>
              <span>Salva e duplica</span>
            </button>
          </div>
        </footer>
      </div>
    </div>
  </b-collapse>
</template>

<script>
import isEmpty from "lodash/isEmpty"
import { get, call } from "vuex-pathify"

import dateHelpers from "@/mixins/dateHelpers"
import ModelAutocomplete from "@/components/forms/ModelAutocomplete"
import EstimateProxy from "@/proxies/EstimateProxy"

export default {
  components: { ModelAutocomplete },
  mixins: [dateHelpers],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    submitAction: {
      type: Function,
      default: call("estimates/update")
    },
    redirectRoute: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      componentKey: 0, // used to force rerender
      formData: {},
      errors: {}
    }
  },
  computed: {
    customers: get("customers/customers")
  },
  mounted() {
    this.fetchCustomers()
  },
  methods: {
    isEmpty,
    fetchCustomers: call("customers/all"),
    reset() {
      this.errors = {}
      this.formData = {}
      this.componentKey += 1
    },
    update(name, value) {
      this.$set(this.formData, name, value)
    },
    async submit(action = false) {
      try {
        let response, message

        if (!isEmpty(this.item)) {
          // if we're editing
          response = await this.submitAction({
            id: this.item.id,
            data: this.formData
          })
          message = "Modificato con successo"
        } else {
          // if it's a new item
          response = await this.submitAction(this.formData)
          message = "Creato con successo"
        }
        this.$toast.open({
          message,
          type: "is-success"
        })

        if (action == "print") {
          let route = this.$router.resolve({
            name: "estimates.print",
            params: { id: response.id }
          })
          window.open(route.href, "_blank")
        }

        if (action == "duplicate") {
          let duplicate = await new EstimateProxy().duplicate(response.id)
          this.$toast.open({
            message: "Preventivo duplicato con successo",
            type: "is-success"
          })
          this.$router.push({
            name: "estimates.show",
            params: { id: duplicate.id }
          })
        }

        // if the `redirectRoute` prop is set, redirect to the
        // path with that name.
        // as a convention, we always pass an `id` param with
        // the value coming from the previous response.
        if (this.redirectRoute) {
          this.$router.push({
            name: this.redirectRoute,
            params: { id: response.id }
          })
        } else {
          this.reset()
        }
      } catch (response) {
        // show errors in form
        this.errors = {}
        Object.keys(response.data).forEach(key => {
          this.$set(this.errors, key, response.data[key].join(" "))
        })
      }
    }
  }
}
</script>

<style lang="sass">
.columns.is-gapless > .column
  margin-bottom: 10px
.field label
  font-size: 0.8rem
  text-transform: uppercase
</style>
